module.exports = __webpack_public_path__ + "static/media/babhlogo.6152793d.png";